import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { ChevronRightSmall } from 'ui/icons';
import { Label, SegmentWrapper } from 'ui/indexPages/folders/Folders.styles';
import { StyledLargeLink } from 'ui/indexPages/folders/folderBreadcrumbs/BreadcrumbName';
import { colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { pxToRem } from 'utils/convert';
import { hasHorizontalOverflow } from 'utils/elementHelpers';

import {
  PAGE_SEARCH_PARAM,
  PARENT_CAMPAIGN_ID_SEARCH_PARAM,
  UNSET_PARENT_CAMPAIGN_ID,
} from '../constants';

const StyledContainer = styled.div`
  align-items: center;
  background: rgba(230, 251, 255, 0.4);
  border-top: ${spacing.single} solid ${colors.grey15};
  display: flex;
  height: ${pxToRem(50)};
  justify-content: flex-start;
  padding: 0 ${spacing.double};
`;

type Props = {
  parentCampaign?: string;
};

export const RecurringCampaignBreadcrumbs = ({ parentCampaign = 'Recurring Campaign' }: Props) => {
  const [showTip, setShowTip] = useState(false);
  const labelRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (labelRef.current && hasHorizontalOverflow(labelRef.current)) {
      setShowTip(true);
    }
  }, [labelRef]);

  return (
    <StyledContainer data-test="folder-breadcrumb-bar">
      <SegmentWrapper data-test="simple-breadcrumb" isRoot>
        <Label>
          <StyledLargeLink
            searchParams={{
              [PARENT_CAMPAIGN_ID_SEARCH_PARAM]: UNSET_PARENT_CAMPAIGN_ID.toString(),
            }}
            deleteSearchParams={[PAGE_SEARCH_PARAM]}
          >
            All
          </StyledLargeLink>
        </Label>
      </SegmentWrapper>
      <SegmentWrapper data-test="simple-breadcrumb-campaign">
        <ChevronRightSmall />
        <Tooltip isEnabled={showTip} tooltipContent={parentCampaign}>
          <Label isLastItem ref={labelRef}>
            <span>{parentCampaign}</span>
          </Label>
        </Tooltip>
      </SegmentWrapper>
    </StyledContainer>
  );
};
